




















































































































































































































































import {Vue, Component, Prop, Ref, Watch} from "vue-property-decorator"
import GenericTemplate from "@/pages/Pages/Templates/GenericTemplate.vue";
import {MsgTransports} from "@/store/types";
import {Route} from "vue-router";
import SmsTextInputWings from "@/components/SMS/SmsTextInputWings.vue";
import {SelectWings, FieldTooltip, DatePickerWings, InputWings, TextareaWings} from "wings-ui-components";
import {Action, Getter} from "vuex-class";
import {CallTemplateItemImpl} from "@/store/settings/templates/types";
import { IvrMenus, IvrMenuFilter } from "@/store/call/ivr_menus/types";
import { SoundItem } from "@/store/call/sounds/types";
import CascadingOptions from "@/components/Others/CascadingOptions.vue";

Component.registerHooks(["beforeRouteLeave"]);

@Component({components: {CascadingOptions, FieldTooltip, SmsTextInputWings, GenericTemplate, SelectWings, DatePickerWings, InputWings, TextareaWings}})
export default class CallTemplate extends Vue {

  @Prop() moderation!: boolean;

  @Ref("genericTemplate") genericTemplate!: GenericTemplate;

  @Action("getIvrMenus") actionGetIvrMenus!: (payload: IvrMenuFilter) => Promise<void>;
  @Action("getSounds") actionGetSounds!: (payload: any) => Promise<SoundItem[]>;
  @Action("getTemplates") actionGetTemplates: any;

  @Getter("ivrMenus") ivrMenusList!: IvrMenus[];
  @Getter("sounds") soundsList!: SoundItem[];

  private transport: MsgTransports = MsgTransports.CALL;
  private templateObject: CallTemplateItemImpl = new CallTemplateItemImpl();

  private is_sms: boolean = false;
  private is_sms_dtmf: boolean = false;
  private isShowSMSBlock: boolean = true;
  private smsTemplatesList: any[] = [];
  private callKeysList: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '#'];

  payloadType: string[] = [
    'ivrmenu',
    'file',
    'text',
  ]

  created() {
    this.actionGetIvrMenus(new IvrMenuFilter());
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }

  onLoadTemplate(status: string) {
    if (this.moderation) {
      this.$emit('onLoadTemplate', status)
    }
  }

  async onChangeTemplate(data: CallTemplateItemImpl) {
    const savedContent = data.content;
    this.templateObject = data;
    this.is_sms = !!data.sending_sms_template_id;
    this.is_sms_dtmf = !!data.sending_sms_dtmf;
    await this.$nextTick();
    this.templateObject.content = savedContent;
    if (data.sending_sms_template_id && data.partner_id) {
      this.smsTemplatesList = await this.actionGetTemplates({
        filter: { id: data.sending_sms_template_id },
        transport: 'sms',
      });
    }
  }

  async getSmsTemplatesList(filter: any) {
    try {
      const items = await this.actionGetTemplates({
        filter: { partner_id: this.templateObject.partner_id, is_active: 1, ...filter },
        transport: 'sms',
      });
      this.smsTemplatesList = (filter?.page_number > 1) ? this.smsTemplatesList.concat(items) : items;
    } catch (error) {
      if (parseInt((error as any)?.response?.data?.errorCode) === 24) {
        this.isShowSMSBlock = false;
      } else {
        throw error;
      }
    }
  }

  @Watch('is_sms')
  onIsSmsChange(val: boolean) {
    if (!val) {
      this.templateObject.sending_sms_template_id = null;
      this.templateObject.sending_sms_dtmf = '';
      this.is_sms_dtmf = false;
    }
  }

  @Watch('is_sms_dtmf')
  onIsSMSDtmfChange(val: boolean) {
    if (!val) {
      this.templateObject.sending_sms_dtmf = '';
    }
  }

  async getSoundsList(filter: any) {
    if (!this.templateObject.partner_id) {
      return [];
    }
    const filterParams: any = {
      partner_id: this.templateObject.partner_id
    };
    if (filter?.page_number) {
      filterParams.page_number = filter.page_number;
    }
    const items = await this.actionGetSounds(filterParams);
    return items;
  }

  @Watch('templateObject.payload_type')
  onChangeContent() {
    this.templateObject.content = '';
    if (this.templateObject.payload_type === 'file' && this.templateObject.partner_id) {
      this.getSoundsList({});
    }
  }

  @Watch('templateObject.partner_id')
  onPartnerChange() {
    if (this.templateObject.payload_type === 'file') {
      this.templateObject.content = '';
      if (this.templateObject.partner_id) {
        this.getSoundsList({});
      }
    }
  }
}
